module.exports = __webpack_public_path__ + "img/optionB.4ddec795.png";